import { useState } from "react";
import { Filter, ChevronDown, Check } from "lucide-react";

const ServiceFilter = ({ serviceNames, selectedService, onServiceChange }) => {
  const [isOpen, setIsOpen] = useState(false);

  const getServiceName = () => {
    if (selectedService === "ALL") return "All Services";
    const maxLength = 20;
    if (selectedService.length > maxLength) {
      return selectedService.substring(0, maxLength) + "...";
    }
    return selectedService;
  };

  const handleServiceSelect = (service) => {
    onServiceChange(service);
    setIsOpen(false);
  };

  return (
    <div className="relative w-full sm:w-auto">
      <button
        onClick={() => setIsOpen(!isOpen)}
        className="flex items-center justify-between gap-2 px-3 sm:px-4 py-2 bg-primary-cyan text-white rounded-lg hover:opacity-90 transition-all font-medium w-full sm:w-auto min-w-[160px] text-sm sm:text-base"
      >
        <span className="flex items-center gap-2">
          <Filter size={16} />
          <span className="truncate">{getServiceName()}</span>
        </span>
        <ChevronDown size={14} className={`transition-transform ${isOpen ? 'rotate-180' : ''}`} />
      </button>

      {isOpen && (
        <div className="absolute top-full mt-2 left-0 right-0 sm:left-auto sm:right-0 bg-card-bg rounded-xl shadow-lg border border-border-color z-50 min-w-[200px] max-h-80 overflow-y-auto">
          <button
            onClick={() => handleServiceSelect("ALL")}
            className={`w-full text-left px-3 sm:px-4 py-2 hover:bg-bg-main transition-colors flex items-center justify-between text-sm ${
              selectedService === "ALL" ? 'bg-bg-main text-primary-cyan' : 'text-primary-dark'
            }`}
          >
            All Services
            {selectedService === "ALL" && <Check size={14} />}
          </button>
          
          <div className="border-t border-border-color my-1" />
          
          {serviceNames.map((service) => (
            <button
              key={service}
              onClick={() => handleServiceSelect(service)}
              className={`w-full text-left px-3 sm:px-4 py-2 hover:bg-bg-main transition-colors flex items-center justify-between text-sm ${
                selectedService === service ? 'bg-bg-main text-primary-cyan' : 'text-primary-dark'
              }`}
            >
              <span className="truncate">{service}</span>
              {selectedService === service && <Check size={14} className="flex-shrink-0 ml-2" />}
            </button>
          ))}
        </div>
      )}
    </div>
  );
};

export default ServiceFilter;